<template>
    <van-popup v-model="isShow" class="mp-download-app-modal" @close="$emit('on-hide')">
        <div class="content">
            <div class="title">
                <p class="h1">还差一步</p>
                <p class="h2">即可享受{{ name }}</p>
            </div>
            <div class="subtitle">
                <p class="h3">下载全球购骑士特权APP</p>
            </div>
            <div class="buttons">
                <div class="confirm-button" @click="handleConfirm">
                    马上下载
                </div>
                <div class="cancel-button" @click="handleCancel">
                    我再想想
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import Popup from 'vant/lib/popup';
import 'vant/lib/popup/style';
import mpSdk from '@/common/miniProgramSdk';

export default {
    name: 'mp-download-app-modal',
    components: {
        'van-popup': Popup,
    },
    props: {
        name: {
            type: String,
        },
        link: {
            type: String,
        },
    },
    data() {
        return {
            isShow: true,
            downloadLink:
                this.link ||
                'https://mp.weixin.qq.com/s?__biz=MzI2Njk4MTI0OQ==&mid=100507811&idx=1&sn=8ec663b8594588a71dcecd883093fb90&chksm=6a8cda4d5dfb535b082980f5bdffd948df7766e6b3bdb067745e5927d02ef7a651f01bbbc978#rd',
        };
    },
    methods: {
        handleConfirm() {
            mpSdk
                .call('navigateTo', {
                    url: `/pages/webview/index?url=${encodeURIComponent(this.downloadLink)}&needLogin=''`,
                })
                .then(console.log);
        },
        handleCancel() {
            this.isShow = false;
            this.$emit('on-hide');
        },
    },
};
</script>

<style lang="scss" scoped>
.mp-download-app-modal {
    background: none;
    .content {
        width: 6.1rem;
        height: 6.2rem;
        background: url(./download-app-modal@2x.png) no-repeat center center;
        background-size: 100%;
        text-align: center;
    }
    .h1 {
        font-size: 0.32rem;
        font-weight: 500;
        line-height: 0.45rem;
        color: #783e0d;
    }
    .h2 {
        font-size: 0.32rem;
        font-weight: 500;
        line-height: 0.45rem;
        color: #e61b00;
    }
    .h3 {
        font-size: 0.3rem;
        font-weight: 500;
        line-height: 0.42rem;
        color: #783e0d;
    }
    .title {
        padding-top: 0.36rem;
    }
    .subtitle {
        margin-top: 2.04rem;
    }
    .buttons {
        width: 4.2rem;
        margin: 0.74rem auto 0;
    }
    .confirm-button {
        font-size: 0.36rem;
        font-weight: 500;
        line-height: 0.9rem;
        color: #904709;
    }
    .cancel-button {
        font-size: 0.24rem;
        line-height: 0.33rem;
        padding: 0.24rem 0;
        color: #fff;
        opacity: 0.4;
    }
}
</style>
